import React, { useCallback, useEffect, useMemo, useState } from 'react';
import { Box, Dropdown, OptionKey, Text } from '@common-fe/common-fe';

import { Option } from '@/common/types';

interface Props {
  isAutoFocus?: boolean;
  onSetAutoFocus?: (value: boolean) => void;
  options: Option[];
  testId?: string;
  value: OptionKey;
  disabled?: boolean;

  onChangeValue: (value: OptionKey) => void;
}
const SinglePlanSelector: React.FC<Props> = ({
  value,
  testId = 'plan_selector',
  onChangeValue,
  options,
  disabled,
  isAutoFocus = false,
  onSetAutoFocus,
}) => {
  const [expanded, setExpanded] = useState(false);
  const handlePickItem = useCallback(
    (value: OptionKey) => () => {
      onChangeValue(value);
      setExpanded(false);
    },
    [onChangeValue]
  );

  const currentTitle = useMemo(() => {
    if (value) {
      const foundItem = options.find((item) => `${item.key}` === `${value}`);
      return foundItem ? `${foundItem.value}` : undefined;
    }
    return undefined;
  }, [options, value]);
  useEffect(() => {
    if (isAutoFocus) {
      setExpanded(true);
    }
  }, [isAutoFocus]);
  const handleExpanded = (value: boolean) => {
    setExpanded(value);
    if (!value && onSetAutoFocus) {
      onSetAutoFocus(false);
    }
  };

  return (
    <>
      <Dropdown
        placeholder="Select plan name"
        expanded={expanded}
        title={currentTitle}
        onSetExpanded={handleExpanded}
        testId={testId || 'plan_selector'}
        disabled={disabled || !options.length}
      >
        <Box pad="spacing6">
          <Text margin="spacing6" color="textSecondary" size="small">
            Select only one plan to display
          </Text>
          {options.map((item) => (
            <Dropdown.Item key={item.key} isActive={value === item.key} onClick={handlePickItem(item.key)}>
              {`${item.name || item.value || ''}`}
            </Dropdown.Item>
          ))}
        </Box>
      </Dropdown>
    </>
  );
};

export default SinglePlanSelector;
